export enum LIBROS_TYPES {
  LIBRO_CHANGE_FORM_VENTAS = 'LIBRO_CHANGE_FORM_VENTAS',
  LIBRO_CHANGE_FORM_CONSULTA_VENTAS = 'LIBRO_CHANGE_FORM_CONSULTA_VENTAS',
  LIBRO_SET_DATA_CONSULTA_VENTAS = 'LIBRO_SET_DATA_CONSULTA_VENTAS',
  LIBRO_VENTAS_SET_TABLE_PAGINAS = 'LIBRO_VENTAS_SET_TABLE_PAGINAS',
  LIBRO_VENTAS_SET_TABLE_PAGINA_ACTUAL = 'LIBRO_VENTAS_SET_TABLE_PAGINA_ACTUAL',
  LIBRO_HISTORIAL_VENTAS_SET_CONSULTA_LIBROS = 'LIBRO_HISTORIAL_VENTAS_SET_CONSULTA_LIBROS',
  LIBRO_CHANGE_FORM_CONSULTA_LIBROS = 'LIBRO_CHANGE_FORM_CONSULTA_LIBROS',
  LIBROS_CLEAR_MODULE = 'LIBROS_CLEAR_MODULE',
  VENTAS_MODAL_FORMATOS_DESCARGAS = 'VENTAS_MODAL_FORMATOS_DESCARGAS',
  VENTAS_MODAL_CARGAR_FORMATOS = 'VENTAS_MODAL_CARGAR_FORMATOS',
  VENTAS_SET_RETENCIONES_DETECTADAS = 'VENTAS_SET_RETENCIONES_DETECTADAS',
  VENTAS_SET_INCLUIR_RETENCIONES = 'VENTAS_SET_INCLUIR_RETENCIONES',

  COMPRAS_CHANGE_FORM_CARGA = 'COMPRAS_CHANGE_FORM_CARGA',
  COMPRAS_SET_LIBRO_ACTIVO = 'COMPRAS_SET_LIBRO_ACTIVO',
  COMPRAS_SET_DATA_LIBROS = 'COMPRAS_SET_DATA_LIBROS',
  COMPRAS_SET_FILE_DATA_CARGADA = 'COMPRAS_SET_FILE_DATA_CARGADA',

  JSON_RESPONSE_HACIENDA_DTE = 'JSON_RESPONSE_HACIENDA_DTE'
}
